// extracted by mini-css-extract-plugin
export default {"Sidebar":"style_Sidebar__sW5FO","isOpen":"style_isOpen__oPyed"};